import { Grid, Slide } from '@material-ui/core'
/* eslint-disable import/order */
import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../../resources/theme/users'
import { edit, update } from '../SupplierActions'
import Form from './Form'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import colors from '../../../assets/colors'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

function EditSupplier(props) {
  const { classes } = props

  const dispatch = useDispatch()
  const history = useHistory()

  const supplier = useSelector(state => state.supplier.editingSupplier)

  const onSubmit = values => {
    dispatch(update(values)).then(data => {
      if (data && data.code === 200) {
        onClose()
      }
    })
  }

  const onClose = () => {
    history.goBack()
  }

  useEffect(() => {
    dispatch(edit(props.match.params.id))
  }, [])

  return (
    <BaseFilterModal open handleOpen={onClose} title="Editar Contato">
      <Grid
        container
        alignItems="center"
        item
        xs={12}
        justifyContent="flex-start"
        style={{ width: '620px' }}
        spacing={1}
      >
        <Grid item xs={12}>
          <Typography
            style={{ fontSize: '16px', fontWeight: 'normal' }}
            color={colors.primary}
          >
            Utilize os campos para editar um contato
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Form data={supplier} onClose={onClose} onSubmit={onSubmit} />
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default withStyles(styles)(EditSupplier)
